import { type EssentialInfoV2_organization$key } from '#app/__generated__/relay/EssentialInfoV2_organization.graphql.js';
import { useMatchMedia } from '#app/hooks/useMatchMedia.js';
import { parseMediaQueryForMatchMedia } from '#app/utilities/parseMediaQueryForMatchMedia.js';
import { Container, Item, NameText, Row } from './EssentialInfo.styles.js';
import { Website } from './Website.js';
import { CommunityOutlineIcon, LocationIcon } from '@contra/icons/icons';
import { graphql, useFragment } from '@contra/relay';
import { ReactNode } from 'react';
import { useTheme } from 'styled-components';

type EssentialInfoProps = {
  readonly memberSinceBadge?: ReactNode;
  readonly organizationRef: EssentialInfoV2_organization$key;
};

export const EssentialInfoV2 = ({
  memberSinceBadge,
  organizationRef,
}: EssentialInfoProps) => {
  const data = useFragment<EssentialInfoV2_organization$key>(
    graphql`
      fragment EssentialInfoV2_organization on Organization {
        name
        url
        visitorCanEdit
        location
        numberOfIndependentsHired
      }
    `,
    organizationRef,
  );
  const theme = useTheme();
  const isMediumScreen = useMatchMedia(
    parseMediaQueryForMatchMedia(theme.mediaQueries.md),
  );

  const { name, url } = data;

  const freelancersHiredText =
    data.numberOfIndependentsHired > 1
      ? 'freelancers hired'
      : 'freelancer hired';

  return (
    <Container>
      <NameText>
        {name}
        {memberSinceBadge}
      </NameText>

      <Row>
        {isMediumScreen && data.location ? (
          <Item textStyle={['bodySmall', 'bodyRegular']}>
            <LocationIcon size={16} /> {data.location}
          </Item>
        ) : null}

        <Website
          url={url}
          visitorCanEdit={data.visitorCanEdit}
        />

        {isMediumScreen && data.numberOfIndependentsHired ? (
          <Item textStyle={['bodySmall', 'bodyRegular']}>
            <CommunityOutlineIcon size={16} />{' '}
            {data.numberOfIndependentsHired.toLocaleString()}{' '}
            {freelancersHiredText}
          </Item>
        ) : null}
      </Row>
    </Container>
  );
};
